<template>
  <div>
    <validation-observer ref="conclusaoForm">
      <b-form @ubmit.prevent>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Resultado">
              <b-form-textarea
                v-model="conclusao.resultado"
                :disabled="disableForm"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Descrição">
              <b-form-textarea
                v-model="conclusao.descricao"
                :disabled="disableForm"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Conclusão"
            label-save="Salvar Conclusão"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      conclusao: {},
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && newVal.conclusao) {
          this.setConclusaoData(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair da atualização do Conclusão?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setConclusaoData(this.parecer);
      this.$refs.conclusaoForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setConclusaoData(data) {
      if (data && !!data.conclusao) {
        this.conclusao = {
          id: data.id,
          ...this.conclusao,
          ...data.conclusao,
        };
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.conclusaoForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarConclusao",
                this.conclusao
              )
              .then((response) => {
                this.conclusao = {
                  id: response.data.id,
                  ...response.data.conclusao,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Conclusão Editada com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
